var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "auto",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 13.3335H8.16667C7.70633 13.3335 7.33333 12.9605 7.33333 12.5002V9.50016C7.33333 9.13183 7.035 8.8335 6.66667 8.8335H5.33333C4.965 8.8335 4.66667 9.13183 4.66667 9.50016V12.5002C4.66667 12.9605 4.29367 13.3335 3.83333 13.3335H0.833333C0.373 13.3335 0 12.9605 0 12.5002V6.13783C0 5.3715 0.351333 4.6475 0.953 4.1735L5.69033 0.440496C5.872 0.297829 6.128 0.297829 6.30933 0.440496L11.0473 4.1735C11.649 4.6475 12 5.37116 12 6.13716V12.5002C12 12.9605 11.627 13.3335 11.1667 13.3335Z",
    fill: "auto"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.df9884ac9e3754e5e905a45b99e43dd3.svg";
export { ForwardRef as ReactComponent };